import Vue from 'vue'
import vSelect from 'vue-select'

Vue.component('VSelect', {
  extends: vSelect,

  data() {
    return {
      focusVisible: false,
      pointerFocusing: false,
    }
  },

  computed: {
    stateClasses() {
      return {
        ...vSelect.computed.stateClasses.call(this),
        'vs--focus-visible': this.focusVisible,
      }
    },
  },

  methods: {
    toggleDropdown(event) {
      this.focusVisible = false
      this.pointerFocusing = true

      try {
        return vSelect.methods.toggleDropdown.call(this, event)
      } finally {
        this.pointerFocusing = false
      }
    },

    onSearchFocus() {
      this.focusVisible = !this.pointerFocusing

      return vSelect.methods.onSearchFocus.call(this)
    },

    onSearchBlur() {
      this.focusVisible = false

      return vSelect.methods.onSearchBlur.call(this)
    },
  },
})
